import { createSlice } from '@reduxjs/toolkit'

const initialState: { listScannedIp: any[] } = {
  listScannedIp: [],
}

const deviceIpSlice = createSlice({
  name: 'deviceIp',
  initialState,
  reducers: {
    setListScannedIp: (state, action) => {
      state.listScannedIp = action.payload || []
    },
    addScannedIp: (state, action) => {
      state.listScannedIp = [action.payload, ...state.listScannedIp]
    },
  },
})

export const { setListScannedIp, addScannedIp } = deviceIpSlice.actions
export default deviceIpSlice.reducer
